import MyModal from '@/components/my-modal';
import ContactsList from '@/components/contacts-list';
import type { Contact } from '@/contexts/contacts/types';
import { useContactsContext } from '@/contexts/contacts/context';
import { useChatContext } from '@/contexts/chat/context';
import EmptyIcon from './images/empty-ghost.png';
import styles from './index.module.scss';

export default function SelectContact() {
  const { createChat, activeChat } = useChatContext();
  const { contacts } = useContactsContext();
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState<string>('');

  const contacts_ = useMemo(() => {
    return contacts.filter((item) => item.name?.includes(searchText));
  }, [searchText, contacts]);

  const onSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  }, []);

  const onContactClick = useCallback(
    async (contact: Contact) => {
      const user_ = Object.assign(contact, {
        label: contact.name,
        value: contact.user_id,
        userId: contact.user_id,
      });
      const chat = await createChat({ userId: user_.userId });
      if (chat) {
        activeChat(chat.chat_id);
      }
      setOpen(false);
    },
    [activeChat, createChat]
  );

  useEffect(() => {
    if (open) {
      setSearchText('');
    }
  }, [open]);

  return (
    <div className={styles.selectContact}>
      <div className={styles.emptyIcon}>
        <img src={EmptyIcon} />
      </div>
      <div className={styles.emptyTitle}>You have no conversations yet!!</div>
      <Button type="primary" onClick={() => setOpen(true)}>
        New Message
      </Button>

      <MyModal
        open={open}
        cancelText="Cancel"
        title="Select Contact"
        onCancel={() => setOpen(false)}
        actionText={null}
        modalProps={{ destroyOnHidden: true, centered: true }}
      >
        <div className={styles.content}>
          <div className={styles.search}>
            <Input
              prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              variant="filled"
              placeholder="Search"
              value={searchText}
              onChange={onSearch}
            />
          </div>
          <div className={styles.contacts}>
            <ContactsList contacts={contacts_} onContactClick={onContactClick} />
          </div>
        </div>
      </MyModal>
    </div>
  );
}
